
import type { PropType } from 'vue'

import type { 
    DispatcherWorkplaceDataEntity,
    DispatcherWorkplaceTake,
    DispatcherWorkplaceDelivery,
    DispatcherWorkplaceItem
} from '@/modules/DispatcherWorkplaceModule/types'

import { defineComponent, computed } from 'vue'

import DwSidebarEntity from './Entity.vue'
import DwSidebarFilter from './Filter.vue'

export default defineComponent({
    components: {
        'dw-sidebar-entity': DwSidebarEntity,
        'dw-sidebar-filter': DwSidebarFilter
    },
    props: {
        entities: {
            type: Array as PropType<Array<DispatcherWorkplaceDataEntity>>,
            required: true
        },
        isWaitListEnabled: {
            type: Boolean,
            default: false,
        },
        isDowntimeEnabled: {
            type: Boolean,
            default: false,
        },
        isDelayingEnabled: {
            type: Boolean,
            default: false,
        },
        isCompletedOrdersEnabled: {
            type: Boolean,
            default: false,
        },
        selectedSidebarFeatureId: {
            type: String as PropType<string | null>,
            default: null
        }
    },
    emits: ['entity-clicked'],
    setup(props, { emit }) {
        const onEntityClicked = (entity: DispatcherWorkplaceDataEntity) => {
            emit('entity-clicked', entity)
        }

        const isTakeCompleted = (entity: DispatcherWorkplaceDataEntity) => {
            if (entity.type === 1) {
                return entity.state === 1 || entity.statusId === 3
            }

            return false
        }

        const isDeliveryCompleted = (entity: DispatcherWorkplaceDataEntity) => {
            if (entity.type === 2) {
                return entity.state === 1
            }

            return false
        }

        const isFeatureEntityCompleted = (entity: DispatcherWorkplaceDataEntity) => {
            if (entity.type === 1) {
                return isTakeCompleted(entity)
            }

            if (entity.type === 2) {
                return isDeliveryCompleted(entity)
            }

            return false
        }

        const sortOrders = (orders: DispatcherWorkplaceDataEntity[]): DispatcherWorkplaceDataEntity[] => {
            return orders.sort((a, b) => {
                const getPriority = (order: DispatcherWorkplaceDataEntity): number => {
                    if (order.type === 1 && (order as DispatcherWorkplaceTake).notAssigned) return 0 // Неназначенные заборы
                    if (order.type === 2 && (order as DispatcherWorkplaceDelivery).notDelivered) return 1 // Невыданные доставки
                    if (!isFeatureEntityCompleted(order)) return 2 // Незавершённые
                    return 3 // Завершённые
                }

                return getPriority(a) - getPriority(b)
            })
        }

        const computedEntities = computed(() => {
            let ordersToRender: DispatcherWorkplaceDataEntity[] = []

            const completedWaitList = props.entities.filter((order) => Boolean(order.waitListStatus) && isFeatureEntityCompleted(order))
            const waitList = props.entities.filter((order) => Boolean(order.waitListStatus) && !isFeatureEntityCompleted(order))

            const completedDowntime = props.entities.filter((order) => Boolean(order.downtimes.length) && isFeatureEntityCompleted(order))
            const downtime = props.entities.filter((order) => Boolean(order.downtimes.length) && !isFeatureEntityCompleted(order))

            const delaying = props.entities.filter((order) => Boolean(order.delaying))

            // ordersToRender = props.entities.filter((order) => {
            //     const isCompleted = isFeatureEntityCompleted(order)
            //     const isWaitList = Boolean(order.waitListStatus)
            //     const isDowntime = Boolean(order.downtimes.length)
            //     const isDelaying = Boolean(order.delaying)

            //     return !isCompleted && !isWaitList && !isDowntime && !isDelaying
            // })

            if (props.isCompletedOrdersEnabled) {
                if (props.isWaitListEnabled) {
                    ordersToRender = ordersToRender.concat(completedWaitList)
                }

                if (props.isDowntimeEnabled) {
                    ordersToRender = ordersToRender.concat(completedDowntime)
                }
            } else {
                if (props.isWaitListEnabled) {
                    ordersToRender = ordersToRender.concat(waitList)
                }

                if (props.isDowntimeEnabled) {
                    ordersToRender = ordersToRender.concat(downtime)
                }
            }

            if (props.isDelayingEnabled) {
                ordersToRender = ordersToRender.concat(delaying)
            }

            return sortOrders(ordersToRender)
        })

        return {
            onEntityClicked,
            computedEntities,
        }
    }
})
